<app-modal
  #deleteImpactModal
  [modalMessage]="app.text.impact.deleteMessage"
  [modalTitle]="app.text.impact.modalTitle"
  (ok)="app.impact.delete(app.impact.currentImpact)"
></app-modal>
<app-modal
  #discardChangesModal
  [modalMessage]="app.text.impact.discard"
  (ok)="
    discardChanges();
    app.impact.impactNameExist = false;
    discardChangesModal.close()
  "
  >
</app-modal>

<div class="controls">
  <app-unlock
    [id]="app.impact.id"
    [permission]="
      app.impact.hasEditPermission(app.impact.id) && !app.impact.isNew
    "
    [title]="app.text.impact.editImpact"
    >
    @if (
      app.impact.modelHasChanges || app.impact.isNew) {
      @if (
        app.field.getInvalidFields('impact', app.impact.currentImpact)
        .length < 1 && app.impact.modelHasChanges
        ) {
        <button
          class="btn"
          (click)="app.impact.save()"
          [title]="app.text.impact.save"
          >
          <i class="fa fa-check"></i>
        </button>
      }
      <button
        class="btn"
        (click)="discardChangesModal.open()"
        [title]="app.text.impact.discard"
        >
        <i class="fa fa-times"></i>
      </button>
    } @else {
      <button
        class="btn"
        (click)="
          app.routing.navigateThread(app.thread.thread['thread._id']);
          app.unlockedId = null
        "
        [title]="app.text.impact.close"
        >
        <i class="fa fa-times"></i>
      </button>
    }

  </app-unlock>
  @if (app.unlockedId == null) {
    <span>
      @if (!app.impact.isNew) {
        <span>
          @if (app.impact.hasEditPermission(app.impact.id)) {
            <button
              class="btn"
              (click)="deleteImpactModal.open()"
              [title]="app.text.impact.deleteImpact"
              >
              <i class="fa fa-trash"></i>
            </button>
          }
          <button
            class="btn"
            (click)="discardChanges()"
            [title]="app.text.impact.close"
            >
            <i class="fa fa-times"></i>
          </button>
        </span>
      }
    </span>
  }
</div>
@if (
  app.field.getInvalidFields('impact', app.impact.currentImpact).length > 0 ||
  app.impact.impactNameExist
  ) {
  <div
    class="row error-message"
    >
    @if (app.unlockedId !== null) {
      <span>
        {{ app.text.impact.messageInvalidForm }}
        <ul>
          @for (
            invalidField of app.field.getInvalidFields(
            'impact',
            app.impact.currentImpact
            )
            ; track
            invalidField) {
            <li
              >
              {{ app.field.getLabel(invalidField) }}
            </li>
          }
        </ul>
        @if (app.impact.impactNameExist) {
          <ul>
            <li>
              {{ app.text.impact.impactNameExist }}
            </li>
          </ul>
        }
      </span>
    }
  </div>
}

<!-- ALL clients vehicles design, except DB  -->
@if (app.customers.expectCurrent !== 'db') {
  <app-box
    [box]="app.listId.impact.fields"
    [model]="app.impact.currentImpact"
    [unlock]="app.impact.id"
    >
    {{ app.impact.id }}
  </app-box>
}
